import axios from "axios"; // 该处引入axios模块
import { Dialog } from 'vant';
import allApi from "@/http/allApi.js"
import router from "../router";
// 构建axios实例
// setCookie('uuid','9f45ad5b-c4d7-4977-8f09-b61ef73a1df8');

const Axios = axios.create({
    baseURL: "", //发布打包时
    // baseURL: "/api", // 该处url会根据开发环境进行变化（开发）
    timeout: 10000 // 设置请求超时连接时间
});
let uuid = getCookie("uuid");
Axios.interceptors.request.use(
    config => {
        config.url = config.url + "?Authorization=" + uuid;
        // console.log(config.url); // 该处可以将config打印出来看一下，该部分将发送给后端（server端）
        return config; // 对config处理完后返回，下一步将向后端发送请求
    },
    error => {
        // 当发生错误时，执行该部分代码
        console.log(error); //调试用
        return Promise.reject(error);
    }
);
Axios.interceptors.response.use(
    response => {
        // 该处为后端返回整个内容
        const res = response.data; // 该处可将后端数据取出，提前做一个处理


        // let token = localStorage.getItem("token");
        //url例子：www.bicycle.com?id="123456"&Name="bicycle"； 
        // let ifCs = "";
        // if (location.hash.split("?")[1]) {
        //     var url = decodeURI(location.hash.split("?")[1]); //?id="123456"&Name="bicycle";
        //     var object = {};
        //     var str = url.substr(1); //得到?后面的字符串
        //     var strs = str.split("&"); //将得到的参数分隔成数组[id="123456",Name="bicycle"];
        //     for (var i = 0; i < strs.length; i++) {　　　　　　　　 object[strs[i].split("=")[0]] = strs[i].split("=")[1]　　 }
        //     for (let key in object) {
        //         if (key != "token") {
        //             ifCs += key + "=" + object[key] + "&&"
        //         }
        //     }
        //     ifCs = ifCs.substr(0, ifCs.length - 2);
        //     ifCs = "?" + ifCs;
        // }


        if (res.err_code == 401) {
            window.location.href=' http://' + window.location.host + "/user/login?url=" + encodeURIComponent(window.location.href);
            // allApi.getUuid().then(res=>{
            //     setCookie("uuid",res.data.data.uuid);
            //     router.go(0);
            // })
            // if (token == null || token == undefined || token == "") {
            //     let urlss = "/" + location.hash.split("?")[0];
            //     if (ifCs != "") {
            //         urlss += ifCs;
            //     }
            //     Dialog.confirm({
            //             title: '提示',
            //             message: '是否前往登录',
            //         })
            //         .then(() => {
            //             allApi.getLoginurl({
            //                 redirecturl: urlss
            //             }).then(res => {
            //                 location.href = res.data.data.url
            //             })
            //         })
            //         .catch(() => {
            //             router.push("/")
            //         });
            // } else {
            //     router.go(0);
            // }
        }
        if (res.err_code == 402) {
            Dialog.confirm({
                    title: '提示',
                    message: '是否前往认证',
                })
                .then(() => {
                    allApi.getMycertifyurl({
                        redirecturl: "/" + location.hash.split("?")[0]
                    }).then(res => {
                        location.href = res.data.data.url
                    })
                })
                .catch(() => {
                    router.push("/")
                });
        }

        return response;
    },
    error => {
        return Promise.reject(error);
    }
);

//设置名称为name,值为value的Cookie
function setCookie(name, value) {
    var expdate = new Date();
    expdate.setTime(expdate.getTime() +365 * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + value + ";expires=" + expdate.toGMTString() + ";path=/";
}

//获取cookie
function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) != -1) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
export default Axios;